import dayjs from 'dayjs';

import type {Millisecond} from '../Time';

export default function getLocalTimeIfDiffers(
  now: Millisecond,
  timezone: string | undefined,
): string | undefined {
  if (!timezone) {
    return undefined;
  }
  const $ = dayjs(now).tz(timezone);
  if (dayjs().utcOffset() === $.utcOffset()) {
    return undefined;
  }
  return $.format('HH:mm');
}
